import { defineComponent } from "vue";
import { GlobalThemeOverrides, NConfigProvider, NNotificationProvider, NLoadingBarProvider } from "naive-ui";

import Headbar from "~/components/headbar/headbar.vue";
import Footer from '~/components/footer/footer.vue';
import { backgroundColorLight, backgroundColorLighter, backgroundColorMoreLighter, backgroundHoverColor, blueColor, blueLightColor, greenColor, greyLightColor, greyLighterColor, primaryColor, redColor, tertiaryColor, whiteColor, dangerColor, warningColor, blackColor, orangeColor, backgroundColor } from "./variables";
import ModalPrompt from "~/components/modals/modal-prompt.vue";

export default defineComponent({

  components: {
    Headbar,
    Footer,
    NConfigProvider,
    ModalPrompt,
    NNotificationProvider,
    NLoadingBarProvider
  },

  data() {
    return {
      themeOverride: {
        common: {
          primaryColor: primaryColor,
          errorColor: redColor,
          warningColor: orangeColor,

          borderRadius: '8px',

          popoverColor: backgroundColorLight,
          hoverColor: backgroundColorLighter,
          actionColor: backgroundColorLighter,
          inputColor: backgroundColorLighter,
          textColor1: whiteColor,
          textColor3: whiteColor,
          textColorBase: whiteColor,
          textColor2: whiteColor,

          borderColor: 'none',          
          optionTextColorActive: greenColor,
          optionCheckMarkColor: greenColor,
        },

        Alert: {
          colorError: redColor,
          iconColorError: whiteColor,
          borderError: redColor,
        },

        AutoComplete: {
          
        },

        Button: {
          textColor: '#ffff',
      
          colorHoverPrimary: blueLightColor,
          borderHoverPrimary: blueLightColor,
          borderFocusPrimary: blueLightColor,
          colorFocusPrimary: blueColor,
          textColorPrimary: whiteColor,

          colorTertiary: tertiaryColor,
          colorTertiaryHover: greyLightColor,
          borderTertiary: greyLightColor,
          
          textColorTertiaryHover: whiteColor,
          textColorTertiary: whiteColor,
          textColorTextPrimary: whiteColor,
          textColorGhost: whiteColor,
          textColorText: whiteColor,
          textColorInfo: whiteColor,
        },

        Table: {
          tdColor: backgroundColorLight,
          thColor: backgroundColorLighter,
          tdColorHover: 'rgba(72, 75, 78, 0.3)',
          thColorHover: backgroundHoverColor,
          tdTextColor: whiteColor,
          thTextColor: whiteColor,
          thIconColorActive: greenColor,
        },

        DataTable: {
          tdColor: backgroundColor,
          thColor: backgroundColorLighter,
          tdColorHover: 'rgba(72, 75, 78, 0.3)',
          thColorHover: backgroundHoverColor,
          tdTextColor: whiteColor,
          thTextColor: whiteColor,
          thIconColorActive: greenColor,
          borderColor: greyLightColor
        },

        Form: {
          labelTextColor: whiteColor,
        },

        LoadingBar: {
          height: '4px',
          colorLoading: greenColor,
        },

        Dialog: {
          color: 'yellow',
        },

        Card: {
          color: backgroundColorLight,
          borderColor: greyLightColor,
          textColor: whiteColor,
          titleTextColor: whiteColor,
        },

        Notification: {
          textColor: whiteColor,
          headerTextColor: whiteColor,
          actionTextColor: greenColor,
          descriptionTextColor: whiteColor,
        },

        List: {
          color: backgroundColorLight,
        },

        Divider: {
          color: backgroundColorLighter,
        },

        Pagination: {
          itemTextColor: whiteColor,
          
          itemTextColorActive: whiteColor,
          itemColorActive: greenColor,
          itemBorderActive: greenColor,
          itemColorActiveHover: greenColor,

          itemColorHover: greenColor,
          itemTextColorHover: whiteColor,

          buttonColor: backgroundColorLighter,

          itemColorDisabled: backgroundColorLighter,
          itemBorderDisabled: backgroundColorLighter,
        },
        Input: {
          color: backgroundColorLighter,
          colorFocus: backgroundColorLighter,
          textColor: whiteColor,
          border: backgroundColorLighter,
          borderRadius: '8px',
          caretColor: whiteColor,
          colorDisabled: backgroundColorMoreLighter,
          textColorDisabled: blackColor,
          loadingColor: greenColor,
          
        },
        // Menu: {
        //   itemColorHover: backgroundColorLighter,
        //   itemColorActive: backgroundColorLighter,
        // },
        DatePicker: {
          panelColor: backgroundColorLight,
          panelTextColor: whiteColor,
          calendarTitleTextColor: whiteColor,
          itemTextColor: whiteColor,
          // arrowColor: greenColor,
          calendarDividerColor: backgroundColorLighter, 
          iconColor: backgroundColorLighter,
          panelActionDividerColor: greyLightColor,
          itemColorIncluded: greyLightColor,
          calendarDaysDividerColor: backgroundColorLighter,
          itemColorActive: greenColor,
          calendarDaysTextColor: greenColor,
          itemBorderRadius: '8px',
        },

        Spin: {
          color: greenColor,
        },

        Checkbox: {
          color: backgroundColorLighter,
          colorChecked: greenColor,
        },

        Dropdown: {
          textColor: whiteColor,
          optionTextColorActive: greenColor,
          optionColorActive: greenColor,
          optionCheckMarkColor: greenColor,
        },

        Cascader: {
          textOptionColorActive: greenColor,
          optionTextColorActive: greenColor,
          optionCheckMarkColor: greenColor,
        },

        Descriptions: {
          thTextColor: greenColor,
          titleTextColor: greenColor,
        },

        Tabs: {
          tabTextColorLine: whiteColor,
          tabTextColorActiveLine: greenColor,
          tabTextColorHoverLine: greenColor,
          barColor: greenColor,
          tabBorderColor: greyLighterColor,
          tabTextColorActiveBar: greenColor,
          tabTextColorBar: whiteColor,
          tabTextColorHoverBar: greenColor,
        },

        Tag: {
          colorBordered: backgroundColorLighter,
          colorChecked: greenColor,
          colorSuccess: greenColor,
          colorWarning: warningColor,
          colorError: dangerColor,
          textColorSuccess: blackColor,
          textColorError: whiteColor,
          textColorWarning: whiteColor,
        },

        Timeline: {
          titleTextColor: whiteColor,
          titleFontWeight: 'bold',
        },

        TreeSelect: {
          menuColor: blueColor,
          optionCheckMarkColor: greenColor,
        },
      } as GlobalThemeOverrides ,
      showHeadbar: true,
    }
  },

  watch: {
    $route(to) {
      this.showHeadbar = to.meta.headbar;
    }
  }

});